import config from "config/config";
import HandleApiResponse from "utils/handleApiResponse";

const probationManagement = () => {
  const { handleResponse, handleError } = HandleApiResponse();

  async function getProbationManagementDataAPI(values) {
    try {
      const obj = {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      };
      const query = JSON.stringify(values);
      const res = await fetch(
        `${config.host}/panel/probation-management?query=${query}`,
        obj,
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function updateProbationManagementDataAPI(value) {
    try {
      const obj = {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(value),
      };
      const res = await fetch(
        `${config.host}/panel/probation-management/update`,
        obj,
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

    async function getProbationManagementDetailsAPI(values) {
    try {
      const obj = {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      };
      const query = JSON.stringify(values);
      const res = await fetch(
        `${config.host}/panel/probation-management/details?query=${query}`,
        obj,
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  return {
    getProbationManagementDataAPI,
    updateProbationManagementDataAPI,
    getProbationManagementDetailsAPI
  };
};

export default probationManagement;
